import { Link } from "react-router-dom";
import styles from "./Logo.module.scss";

const Logo = ({ size }) => {
  return (
    <div className={styles.logo} style={{ fontSize: size }}>
      <Link to="/">
        <i className="fa-solid fa-tree"></i>
        Grahns Trädgård
      </Link>
    </div>
  );
};

export default Logo;
